import { Router } from "@angular/router";
import { catchError, of, Observable } from "rxjs";
import { AuctionService } from "../services/auction.service";

export function initializeCoreFactory(auctionService: AuctionService, router: Router): () => Observable<any> {
  return () => auctionService.getDefaultData().pipe(
    // If default data fails during app init, don't try to navigate here.
    // Router may not be ready yet. Resolve initializer gracefully.
    catchError(() => of(null))
  );
}
